import React from "react";
import { Control } from "react-hook-form";
import { UseFormSelect } from "./UseFormSelect";
import { SxProps } from "@mui/material";
import { useTranslation } from "react-i18next";

interface UseFormSelectCancelReasonProps {
  control: Control
  name: string
  sx: SxProps
}

export const UseFormSelectCancelReason: React.FC<UseFormSelectCancelReasonProps> = ({
  control,
  name,
  sx = {}
}) => {
  const { t } = useTranslation()
  
  return (
    <UseFormSelect
      control={control}
      name={name}
      items={[
        {value: '', label: ''},
        {value: 'PRICE_DOESNOT_MATCH', label: t('contact_order_detail.price_doesnot_match')},
        {value: 'OUT_OF_STOCK_ESTIMATED', label: t('contact_order_detail.out_of_stock_estimated')},
        {value: 'OUT_OF_STOCK_ORDER', label: t('contact_order_detail.out_of_stock_order')},
        {value: 'POOR_CONDITION_DETAILS', label: t('contact_order_detail.poor_condition_details')},
        {value: 'EXCESSIVE_QUANTITY_BEFORE_ESTIMATED', label: t('contact_order_detail.excessive_quantity_before_estimated')},
        {value: 'EXCESSIVE_QUANTITY_AFTER_ESTIMATED', label: t('contact_order_detail.excessive_quantity_after_estimated')},
      ]}
      sx={{
        width: '200px',
        ...sx,
      }}
    />
  )
}